import {styled} from '@api';

export * from './LazyImage'
export * from './AddNote'
export * from './SidebarCarousel'
export * from './NotesList'
export * from './ProductAttributes'
export * from './ProductFooter'
export * from './SideBarHeader'
export * from './SideBarList'
// export * from './colorpicker/ColorPicker'
export * from './CustomAttribute'
// export * from './colorpicker/ColorPickerTab'
export * from './Slider'
export * from './EmptyDrawer'
export * from './AddIcon'
export * from './LibrarySidebarTabs'
export * from './SyncProgressBar'
export * from './DragEventPlaceholders'
export * from './MyPopover2'
export * from './JiraIcon'
export * from './ImageSlider'

export const Name = styled.span`
      text-overflow: ellipsis;
      overflow:      hidden;
      flex:          1;   
`

export const Count = styled.span`
        flex: 0 0 auto;  
        color: var(--count-color);
        
        &[data-filtered="true"] {
          /*font-style: italic;*/
        }    
`



// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/index.ts